module.exports = __webpack_public_path__ + "img/seating.6861cd93.png";